<div [attr.id]="'field-level-error-global-message' + (identifier ? ('-' + identifier) : '')">
  <div *ngIf="savedErrorCount > 0" class="sr-only">
    {{errorContent1}}{{savedErrorCount}}{{errorContent2}}
  </div>
</div>